<div class="share-backdrop" (click)="close()">
  <div class="share-card" (click)="$event.stopPropagation()">
    <div class="share-header">
      <div class="share-heading">
        <span class="share-title">Share “{{ topology().name }}”</span>
        <span class="share-subtitle">Recipients can view this topology. Only you can change it.</span>
      </div>
      <button class="share-close" type="button" (click)="close()">✕</button>
    </div>

    @if (error(); as message) {
      <div class="share-error">{{ message }}</div>
    }

    <div class="share-body vg-scroll">
      <div class="share-row">
        <select [value]="selectedUserId()" (change)="onUserChange($event)">
          <option value="">Choose a user…</option>
          @for (user of availableUsers(); track user.id) {
            <option [value]="user.id">{{ displayName(user) }}</option>
          }
        </select>
        <button type="button" [disabled]="!selectedUserId() || busy()" (click)="shareWithUser()">
          Share
        </button>
      </div>

      <div class="share-row">
        <select [value]="selectedOrganizationId()" (change)="onOrganizationChange($event)">
          <option value="">Choose an organization…</option>
          @for (organization of availableOrganizations(); track organization.id) {
            <option [value]="organization.id">{{ organization.name }}</option>
          }
        </select>
        <button
          type="button"
          [disabled]="!selectedOrganizationId() || busy()"
          (click)="shareWithOrganization()"
        >
          Share
        </button>
      </div>

      <h4>Shared with</h4>

      @if (loading()) {
        <p class="share-empty">Loading…</p>
      } @else if (shares().length === 0) {
        <p class="share-empty">Not shared with anyone yet.</p>
      } @else {
        @for (share of shares(); track share.id) {
          <div class="share-entry">
            <span class="share-kind">{{ share.subjectType === 'USER' ? '👤' : '🏢' }}</span>
            <span class="share-name">{{ share.subjectName ?? share.subjectId }}</span>
            <button type="button" class="share-revoke" [disabled]="busy()" (click)="revoke(share)">
              Revoke
            </button>
          </div>
        }
      }
    </div>
  </div>
</div>
